import { drawRaster, toPremulCanvas, toStraightRaster } from './premul-canvas';
import type { Raster } from './raster';
import type { CylinderPreview } from './warp-cylinder';

const ORIGIN = { x: 0, y: 0 } as const;

/**
 * 미리보기를 상품 사진과 곱한다(마플 multiply). 워프한 뒤 제자리에서 곱하고, 마플 캔버스처럼 두 번 저장한다.
 * 1. 미리보기 캔버스에 사진을 multiply 로 그린다. 사진 위치는 배치 left·top 을 내림한 정수 픽셀이다.
 * 2. 미리보기 자신을 destination-in 으로 그려 미리보기 모양 밖을 지운다. 반투명 픽셀은 알파가 한 번 더 곱해진다.
 * 사진이 투명하거나 사진 밖인 곳은 미리보기 색이 남는다. 배치는 그대로 두고 입력은 바꾸지 않는다.
 */
export function multiplyOnPhoto(preview: CylinderPreview, photo: Raster): CylinderPreview {
  const photoOffset = {
    x: -Math.floor(preview.placement.left),
    y: -Math.floor(preview.placement.top),
  };
  const multiplied = drawRaster(toPremulCanvas(preview.raster), photo, photoOffset, 'multiply');
  const clipped = drawRaster(multiplied, preview.raster, ORIGIN, 'destination-in');
  return { raster: toStraightRaster(clipped), placement: preview.placement };
}
